// extracted by mini-css-extract-plugin
module.exports = {"mainButton":"style_mainButton__33qj_","wrapper":"style_wrapper__Zyn_1"};